exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.field-title span {\n    color: #90919e;\n    font-size: 12px;\n    font-weight: 600;\n    vertical-align: middle;\n    margin-right: 5px;\n}\n.field-title img {\n    vertical-align: middle;\n}\n.question-title {\n    margin-bottom: 0.5em;\n}\n.range-selection-wrapper.condensed .question-title {\n    margin: 0;\n}\n.range-selection-wrapper.condensed .question-top .question-icon {\n    display: none;\n}\n.question-title .question-icon {\n    display: inline-block;\n    margin-right: 11px;\n    vertical-align: middle;\n}\n.question-title .title {\n    display: inline-block;\n    vertical-align: middle;\n}\n", ""]);

// exports
